import { useEffect, useState } from 'react';

export function useLightbox() {
    const [isDisplayed, setIsDisplayed] = useState(false);
    const [currentUrl, setCurrentUrl] = useState('');

    useEffect(() => {
        const ev = (e: MouseEvent) => {
            const clickedEl = e.target as HTMLElement;

            if (clickedEl?.tagName == 'IMG' && clickedEl?.dataset.lghtb === 'true') {
                setCurrentUrl((clickedEl as HTMLImageElement).src);
                setIsDisplayed(true);
            }
        };

        window.addEventListener('click', ev);

        return () => {
            window.removeEventListener('click', ev);
        };
    }, []);

    const close = () => {
        setIsDisplayed(false);
        setCurrentUrl('');
    };

    if (isDisplayed) {
        return <div className='fixed bg-[rgba(0,0,0,0.5)] top-0 bottom-0 right-0 left-0 grid place-items-center z-50 lightbox-holder' onClick={close}>
            {/* <div className='bg-white'> */}
            <img src={currentUrl} className='max-w-[80vw] max-h-[80vh]' onClick={e => e.stopPropagation()} />
            {/* </div> */}

            <div className='text-white lightbox-close-button absolute top-[30px] right-[30px] text-2xl cursor-pointer' onClick={close}>
                <i className="fa-solid fa-xmark"></i>
            </div>
        </div>;
    } else {
        return <></>;
    }
}